import { render, staticRenderFns } from "./MasterBatanganAdd.vue?vue&type=template&id=9298b66c&scoped=true"
import script from "./MasterBatanganAdd.vue?vue&type=script&lang=js"
export * from "./MasterBatanganAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9298b66c",
  null
  
)

export default component.exports